// Sélection des boutons
const btnSmall = document.querySelector('.story__txt-size--small');
const btnMedium = document.querySelector('.story__txt-size--medium');
const btnBig = document.querySelector('.story__txt-size--big');

// Fonction pour changer la taille de la police du HTML
const changeFontSize = (size) => {
    document.documentElement.style.fontSize = size;
};

// Événements de clic pour chaque bouton
btnSmall.addEventListener('click', () => changeFontSize('16px'));
btnMedium.addEventListener('click', () => changeFontSize('20px'));
btnBig.addEventListener('click', () => changeFontSize('24px'));
